export const actions = {
    LOGOUT_DO: 'LOGOUT_DO',
    LOGIN_FROM_CODE: 'LOGIN_FROM_CODE',
    USER_INFO_FETCHED: 'USER_INFO_FETCHED',
    ASYNC_FETCH_APP_DATA: 'ASYNC_FETCH_APP_DATA',
    ASYNC_FETCH_CLASS: 'ASYNC_FETCH_CLASS',
    ASYNC_FETCH_COACH_DATA: 'ASYNC_FETCH_COACH_DATA',
    ENROLLMENT_LIST_FETCHED: 'ENROLLMENT_LIST_FETCHED',
    ASYNC_UPDATE_VIDEO_DATA: 'ASYNC_UPDATE_VIDEO_DATA',
    ASYNC_INIT_VIDEO_DATA: 'ASYNC_INIT_VIDEO_DATA',
    ASYNC_UPDATE_ACTIVITY: 'ASYNC_UPDATE_ACTIVITY',
    CLASS_FETCHED: 'CLASS_FETCHED',
    STUDENT_ENROLLMENT_FETCHED: 'STUDENT_ENROLLMENT_FETCHED',
    STUDENT_ENROLLMENT_UPDATED: 'STUDENT_ENROLLMENT_UPDATED',
    UPLOAD_FILE: 'UPLOAD_FILE',
    REQUEST_ERROR: 'REQUEST_ERROR',
    DISMISS_NOTIFICATION: 'DISMISS_NOTIFICATION',
    ASYNC_SUBMIT_TCC: 'ASYNC_SUBMIT_TCC',
    ASYNC_UPDATE_MODULE_DATES: 'ASYNC_UPDATE_MODULE_DATES',
    LOADING_TCC_SUBMISSION: 'LOADING_TCC_SUBMISSION',
    STUDENT_ACTIVITY_UPDATED: 'STUDENT_ACTIVITY_UPDATED',
    TCCS_PROGRESS_UPDATED: 'TCCS_PROGRESS_UPDATED',
    UPDATE_ACTIVITY_STATUS: 'UPDATE_ACTIVITY_STATUS',
    ASYNC_DOWNLOAD_ATTACH: 'ASYNC_DOWNLOAD_ATTACH',
    RESTORE_ALL_REDUCERS: 'RESTORE_ALL_REDUCERS',
    TOGGLE_LOADING_COURSES: 'TOGGLE_LOADING_COURSES',
    SET_LIST_CLASSES: 'SET_LIST_CLASSES',
    SET_CURRENT_CLASSE : 'SET_CURRENT_CLASSE',
    SET_CURRENT_TCCS: 'SET_CURRENT_TCCS',
    ASYNC_UPDATE_TCCS_DATES: 'ASYNC_UPDATE_TCCS_DATES',
    CLEAN_CLASSES: 'CLEAN_CLASSES',
    ASYNC_UPLOAD_FILE_NEW_EAD: 'ASYNC_UPLOAD_FILE_NEW_EAD',
    SET_IS_SAVING_NEW_EAD: 'SET_IS_SAVING_NEW_EAD',
    ASYNC_UPLOAD_ATTACHMENTS: 'ASYNC_UPLOAD_ATTACHMENTS',
    ASYNC_INIT_TEST: 'ASYNC_INIT_TEST',
    DISABLED_REDIRECT: 'DISABLED_REDIRECT',
    SET_LOADING_TESTS_ONLINE: 'SET_LOADING_TESTS_ONLINE',
    ASYNC_UPDATE_VALUE_TCC: 'ASYNC_UPDATE_VALUE_TCC',
    USER_ID_FETCHED: 'USER_ID_FETCHED',
    EXTERNAL_LOGIN: 'EXTERNAL_LOGIN',
    SET_EXTERNAL_LOGIN: 'SET_EXTERNAL_LOGIN',
};



// WEBPACK FOOTER //
// ./src/utils/constants.js